// Using: PopUp.prototype.show("your words");
// The trigger button here in this file is display none
import React, { Component } from 'react';
import imglogo40 from './../../../assets/images/imglogo40.png';
import $ from 'jquery';
import content from './../../data/content.js';

export default class PopUp extends Component {

  show(sentences) {
    $('#popup-context').html("<p>"+sentences+"</p>");
    $('#popup-button').click();

  }

  render() {

    const data = content[0]["page"]["popup"];

    return (
      <div>
        <button id="popup-button" data-toggle="modal" data-target="#popup" ></button>
        <div id="popup" class="modal fade in" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="fixed-card-box popup">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
              <img src={imglogo40} alt="daotoken"></img>

              <h5 id="popup-context" class="text-center"></h5>

              <div class="pull-right">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-default btn-block waves-effect waves-light text-center m-b-20">{data.confirm}</button>
              </div>
              <div class="m-b-10"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/popup.js